import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'

import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component'
import { RouterModule } from '@angular/router'
import { IconComponent } from '../icon'

export interface BreadcrumbItem {
  text: string
  link?: string
  selected?: boolean
}

@Component({
  selector: 'hyperkit-breadcrumb-list',
  templateUrl: './breadcrumb-list.component.html',
  styleUrls: ['./breadcrumb-list.component.scss'],
  standalone: true,
  imports: [BreadcrumbComponent, RouterModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbListComponent {
  @Input() items: BreadcrumbItem[] = []

  // Optional Output for clickable use-cases (like in dialog)
  @Output() breadcrumbClick = new EventEmitter<number>()

  // Add trackBy function to help Angular track breadcrumb items
  trackByFn(index: number, item: BreadcrumbItem): string {
    return item.text // Assuming text is unique
  }
}
